import React from 'react'
import styles from './PrivacyPolicy.module.css'

const PrivacyPolicy = () => {
  return (
    <div className={styles.parentContainer}>
         <div className={styles.mainContainer}>
        <h1 className={styles.heading}>Privacy Policy</h1>
        <h3>Privacy Policy for Cricway - Indian Cricket Live Score and Line Rate Website</h3>
        <p>Cricway (the "website") is a webApplication that provides live cricket scores, updates, and line rates for cricket matches in India. Cricway respects your privacy and is committed to protecting your personal data. This Privacy Policy explains the login process and how we collect, use, and protect your personal data when you use the website.</p>

        <h3>Login Process</h3>
        <p>There are 2 ways through which the user can login:</p>
        <ol className={`${styles.list } ${styles.ol}`}>
            <li>Login with your registered mobile number, get an OTP and login </li>
            <li>Login with your Google account – For that you have to login with your email ID</li>
           
        </ol>
       
        <h3>Data We Collect</h3>
        <p>We may collect the following types of personal data from you when you use the website:</p>
        <p>Personal Information: We may collect your name, email address, phone number, and other contact details when you create an account with us.</p>
        <p>Device Information: We may collect information about the device you use to access the website, such as the model, operating system, and IP address.</p>
        <p>Usage Information: We may collect information about how you use the website, such as which features you use, the pages you visit, and how long you spend on the website.</p>
        <p>Payment Information: If you make a purchase on the website, we may collect your payment information, including credit card information, to process your payment.</p>
        
        <h3>How We Use Your Data</h3>
        <ul className={`${styles.list } ${styles.ul}`}>
            <li>There are 2 ways through which the user can login: </li>
            <li>To personalize your experience by showing you content that is relevant to you.</li>
            <li>To communicate with you about updates and changes to our website, as well as promotions and offers.</li>
            <li>To analyse how our website is used and improve its functionality.</li>
            <li>To detect and prevent fraud and other unauthorized activity.</li>
            <li>To comply with legal obligations.</li>
        </ul>
        
        <h3>Sharing Your Data</h3>
        <p>We do not sell, rent, or share your personal data with third parties for marketing purposes. However, we may share your data with third-party service providers who help us operate the website, such as analytics providers and payment processors. These service providers are contractually bound to use your data only for the purposes of providing services to us and are prohibited from using it for any other purpose.</p> 
        <p>We may also share your data with government authorities or law enforcement agencies if we are required to do so by law or if we believe that such disclosure is necessary to protect our rights or the safety of our users.</p>
       

        <h3>Your Choices and Rights</h3>
        <p>You have the right to access, rectify, or delete your personal data that we have collected from you. You can do this by contacting us at support@cricway.live. You also have the right to object to the processing of your personal data and to withdraw your consent at any time.</p>
        

        <h3>Security</h3>
        <p>We take websiteropriate technical and organizational measures to protect your data from loss, misuse, unauthorized access, disclosure, alteration, and destruction. We use encryption technology to safeguard your personal data and restrict access to it.</p>

        <h3>Wheel of Fortune</h3>
        <p>Welcome to the Wheel of Fortune Daily website ("website") and our exciting gifts program! We want to make sure you have a clear understanding of our policies regarding gifts and their associated timelines. Please read this policy carefully to participate in the program effectively.</p>

        <h3>Gift Distribution</h3>
        <p>Eligibility: All registered website users are eligible to participate in the Wheel of Fortune gifts program.</p>
        <p>Gift Types: Our gifts may include virtual items, discounts, vouchers, or physical products, depending on availability and your location.</p>
        <p>Frequency: The availability of the Wheel of Fortune and gift distribution frequency may vary. Check the website for updates and notifications.</p>

        <h3>Timelines and Redemption</h3>
        <p>Gift Availability: Gifts won through the Wheel of Fortune will be available in your website account shortly after winning.</p>
        <p>Expiry Dates: Gifts may have expiry dates, and it's essential to use them within the specified timeline. Expired gifts may not be reissued.</p>
        <p>Redemption Process: Follow the instructions provided in the website to redeem your gifts. The redemption process may vary depending on the type of gift.</p>


        <h3>Gift Policies</h3>
        <p>Non-Transferable: Gifts are non-transferable and may not be exchanged for cash or transferred to other users.</p>
        <p>Fair Usage: We reserve the right to monitor and prevent abuse or unfair usage of the Wheel of Fortune and gifts program.</p>
        <p>Cancellation: We may cancel or modify the program, gifts, or their policies at any time without prior notice.</p>

        <h3>Changes to Our Privacy Policy</h3>
        <p>We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new Privacy Policy on our website.</p>

        <h3>Contact Us</h3>
        <p>If you have any questions or concerns about our Privacy Policy or our website, please contact us at support@cricway.live.</p>


        </div>
      
    </div>
  )
}

export default PrivacyPolicy
